import { axios } from "../../helper/axios";
import { ConfigTableconstant } from "./ConfigTableConstant";


const ConfigTableApi = {};

ConfigTableApi.getConfigTable = (payload) => {

    return axios.get(ConfigTableconstant.CONFIG_TABLE_API, { params: { id: payload } });


}

ConfigTableApi.UpdateConfigCancel = ( payload ) => {

   
    return axios.put(
        ConfigTableconstant.CONFIG_UPDATE_CANCEL_API, {id:payload.vendor_id, cancellation_time: payload.cancellation_time, grace_time:payload.grace_time,advance_charges:payload.advance_charges  }
    );
  }


export { ConfigTableApi };
